<!--
  第二个卡片：如何获得抽奖码
  - 头部是标题图（只有青色渐变 + 右上角礼盒装饰，没有文字），文字用定位盖上去
  - 白色卡片与卡片同宽（343px），高度由内容撑开
-->
<script lang="ts">
  import type { Snippet } from "svelte";
  import { _ as t } from "svelte-i18n";
  import howTitle from "../assets/images/card/how-title.png";

  interface Props {
    /**
     * 竞赛牌照文案，来自 D5 活动详情的 activityDesc（按 lang 头返回对应语言）。
     * 没有本地兜底文案，接口没返回就留空。
     */
    licenseText?: string;
    /** 白色卡片内容 */
    children?: Snippet;
  }

  let { licenseText = "", children }: Props = $props();
</script>

<!--
  卡片宽 343px（375 - 16*2），无外层底色：白卡与卡片同宽，
  上方 70px 露出标题图的青色渐变（白卡盖住渐变剩下的部分）
  这一层不能加 overflow-hidden，否则礼盒装饰的溢出部分会被裁掉
-->
<div class="relative pt-[70px]">
  <!--
    标题图 744x290@2x：其中卡片区域是 0~686（css 343px），
    礼盒向右溢出 28.5px、向上溢出 15px，所以宽 372px、top -15px
  -->
  <img
    src={howTitle}
    alt=""
    class="absolute left-0 top-[-15px] w-[372px] max-w-none block"
  />

  <!-- 头部文字（图片里没有文字，这里定位上去） -->
  <div class="absolute left-[16px] right-[16px] top-[13px]">
    <p class="how-card-title">{$t("how_title")}</p>
    <!-- 牌照文案只来自接口的 activityDesc，未返回前留空占一行高度，避免标题下方跳动 -->
    <p class="how-card-sub mt-[4px]">{licenseText}</p>
  </div>

  <!-- 内部白色卡片：高度由内容撑开（设计稿 747px 是量出来的结果，不写死） -->
  <div class="relative rounded-[16px] bg-white overflow-hidden">
    {#if children}
      {@render children()}
    {/if}
  </div>
</div>

<style>
  /*
    标题（设计稿）：18px / 600 / line-height 26px / #2E4CE4
    描边 1.5px #FFFFFF、outer alignment
    用 8 向 text-shadow 模拟外描边（-webkit-text-stroke 是居中描边，
    且 paint-order 在 iOS 10 / chrome 54 上不支持）
  */
  .how-card-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0;
    color: #2e4ce4;
    text-shadow:
      1.5px 0 0 #ffffff,
      -1.5px 0 0 #ffffff,
      0 1.5px 0 #ffffff,
      0 -1.5px 0 #ffffff,
      1px 1px 0 #ffffff,
      1px -1px 0 #ffffff,
      -1px 1px 0 #ffffff,
      -1px -1px 0 #ffffff;
  }

  /* 牌照号（设计稿）：12px / 400 / line-height 150% / #2E4CE4 */
  .how-card-sub {
    /* 接口返回前是空串，min-height 占住一行，避免文案出现时下方内容跳一下 */
    min-height: 18px;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0;
    color: #2e4ce4;
  }
</style>
